module.exports = __webpack_public_path__ + "25b04f25b5329ccb1428c88fa3e01b9e.pdf";